import { combineReducers } from "redux";
import campaignDetailsSlice from "./slices/campaignDetailsSlice";
import emailTemplateSlice from "./slices/emailTemplateSlice";
import landingPageSlice from "./slices/landingPageSlice";
import feedbackPageSlice from "./slices/feedbackPageSlice";
import campaignValidationSlice from "./slices/campaignValidationSlice";
import sendSlice from "./slices/campaignSendSlice";
import { reducer as overviewReducer } from "./slices/campaignOverviewSlice";
import campaignFiltersSlice from "./slices/campaignFiltersSlice";
import campaignEntityStateSlice from "./slices/campaignEntityStateSlice";
import campaignTagsSlice from "./slices/campaignTagsSlice";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import withUsersAssignment from "features/Application/reducers/hoc/withUsersAssignment";
import withGroupsAssignment from "features/Application/reducers/hoc/withGroupsAssignment";
import campaignSendsOverviewSlice from "./slices/campaignSendsOverviewSlice";

const namespace = ReducerNamespaceTypes.Library;
const entityPrefix = ReducerEntityPrefixTypes.ThreatDefenceCampaigns;

const peopleReducers = combineReducers({
  assignedUsers: withUsersAssignment(namespace, entityPrefix),
  assignedGroups: withGroupsAssignment(namespace, entityPrefix),
});

const sendReducers = combineReducers({
  create: sendSlice,
  people: peopleReducers,
  overview: campaignSendsOverviewSlice,
});

const base = combineReducers({
  entityState: campaignEntityStateSlice,
  details: campaignDetailsSlice,
  emailTemplate: emailTemplateSlice,
  landingPage: landingPageSlice,
  feedbackPage: feedbackPageSlice,
  campaignValidation: campaignValidationSlice,
  sends: sendReducers,
});

const overview = combineReducers({
  campaigns: overviewReducer,
  filters: campaignFiltersSlice,
});

const reducers = combineReducers({
  base,
  overview,
  tags: campaignTagsSlice,
});

export default reducers;
